// Modules
import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'
// Application
import DesktopImage from 'assets/onboarding-couple-desktop.svg'
import MobileImage from 'assets/onboarding-couple-mobile.svg'

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background-color: #02103f;
    height: 100vh;
    width: 100vw;
    z-index: 5;
`

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 80px;
    > svg {
        height: 24px;
    }
    > button {
        background: none;
        border: none;
        text-decoration: underline;
        color: #0037ff;
        font-size: 16px;
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        z-index: 8;
        &:hover {
            cursor: pointer;
        }

        svg {
            display: none;
        }

        @media screen and (max-width: ${theme.breakpoints[2]}) {
            p {
                display: none;
            }
            svg {
                display: block;
            }
        }
    }

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        margin: 16px;

        > svg {
            height: 16px;
        }
    }
`
export const TextWrapper = styled.div`
    width: 100vw;
    max-width: 556px;
    margin-left: 80px;
    margin-top: 80px;
    z-index: 8;

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 0;
        margin-top: 8px;
    }
`

export const Image = styled.div`
    position: absolute;
    background-image: url(${DesktopImage});
    height: 1660px;
    width: 1460px;
    right: -220px;
    bottom: -550px;
    background-repeat: no-repeat;
    z-index: 4;

    @media screen and (max-width: ${theme.breakpoints[3]}) {
        height: 1411px;
        width: 1241px;
        right: -180px;
        top: -100px;
    }

    @media screen and (max-width: 1225px) {
        height: 996px;
        width: 876px;
        right: -160px;
        top: -20px;
    }

    @media screen and (max-width: ${theme.breakpoints[2]}) {
        height: 796px;
        width: 700px;
        right: -160px;
        bottom: -300px;
        top: auto;
    }

    @media screen and (max-width: ${theme.breakpoints[1]}) {
        height: 637px;
        width: 560px;
        right: -100px;
        bottom: -300px;
        top: auto;
    }

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        position: unset;
        height: 200px;
        width: 200px;
        background-image: url(${MobileImage});
        margin-bottom: 8px;
    }
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: left;

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        flex-direction: column-reverse;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
    }
`

export const Title = styled.h1`
    color: #ffffff;
    @media screen and (max-width: ${theme.breakpoints[0]}) {
        font-size: 20px;
        text-align: center;
        margin: 16px;
    }
`

export const Subtitle = styled.p`
    color: #ffffff;
    margin-top: 24px;
    @media screen and (max-width: ${theme.breakpoints[0]}) {
        text-align: center;
        margin: 0 16px 16px 16px;
        font-size: 13px;
    }
`

export const ButtonGroup = styled.div`
    margin-top: 56px;
    @media screen and (max-width: ${theme.breakpoints[0]}) {
        margin-top: 16px;
    }
`

export const PrimaryButton = styled.button`
    height: 48px;
    color: #ffffff;
    font-size: 16px;
    width: 207px;
    border-radius: 8px;
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    margin-right: 19px;
    background: none;
    border: 1px solid #ffffff;
    font-weight: 600;
    margin-bottom: 16px;

    &:hover {
        cursor: pointer;
    }

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        max-width: 140px;
    }
`

export const SecondaryButton = styled.button`
    height: 48px;
    color: #02103f;
    background-color: #ffffff;
    font-size: 16px;
    width: 207px;
    border-radius: 8px;
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    font-weight: 600;
    &:hover {
        cursor: pointer;
    }

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        max-width: 140px;
    }
`
